import { get } from 'common/utils/request';
export var fetchShowSupervisorThanksOnboardingApi = function () {
    return get("/employees/self/show-supervisor-thanks-onboarding");
};
